// eslint-disable-next-line import/prefer-default-export
/**
 * This config will help to disabled or hidden some field in module detail or module form
 *
 * SCENARIO 1
 * In module `accelitas_bank_account` If we want to disabled field `customer_id` and that field is only enable when filed portfolio_id is selected
 * {
 *     module_code_key: 'accelitas_bank_account',
 *     column_name: 'customer_id',
 *     depend_column_name: 'portfolio_id',
 *     filter: 'portfolio_id'
 * }
 *
 * SCENARIO 2
 * In module `accelitas_bank_account` If we want to disabled field `customer_id` and that field is only enable when filed portfolio_id is selected and value is 3
 * {
 *     module_code_key: 'accelitas_bank_account',
 *     column_name: 'customer_id',
 *     depend_column_name: 'portfolio_id',
 *     depend_value: 3,
 *     filter: 'portfolio_id'
 * }
 *
 * //Todo Allow setup field is disabled or hidden
* */
export const DEPEND_FIELDS = [
  {
    module_code_key: 'template',
    column_name: 'footer_template_id',
    depend_column_name: 'portfolio_id',
    filter: 'portfolio_id'
  },
  {
    module_code_key: 'promotion',
    column_name: 'template_id',
    depend_column_name: 'portfolio_id',
    filter: 'portfolio_id'
  },
  {
    module_code_key: 'loan_dmc',
    column_name: 'loan_id',
    depend_column_name: 'customer_id',
    filter: 'customer_id'
  },
  {
    module_code_key: 'factortrust_activity_audit',
    column_name: 'payment_id',
    depend_column_name: 'loan_id',
    filter: 'loan_id'
  },
  {
    module_code_key: 'customer_sms_message',
    column_name: 'loan_id',
    depend_column_name: 'customer_id',
    filter: 'customer_id'
  },
  {
    module_code_key: 'customer_sms_message',
    column_name: 'payment_id',
    depend_column_name: 'loan_id',
    filter: 'loan_id'
  },
  {
    module_code_key: 'customer_email_message',
    column_name: 'loan_id',
    depend_column_name: 'customer_id',
    filter: 'customer_id'
  },
  {
    module_code_key: 'customer_email_message',
    column_name: 'payment_id',
    depend_column_name: 'loan_id',
    filter: 'loan_id'
  },
  {
    module_code_key: 'customer_reward',
    column_name: 'loan_id',
    depend_column_name: 'customer_id',
    filter: 'customer_id'
  },
  {
    module_code_key: 'customer_reward',
    column_name: 'payment_id',
    depend_column_name: 'loan_id',
    filter: 'loan_id'
  },
  {
    module_code_key: 'payment_return_file',
    column_name: 'payment_processor_id',
    depend_column_name: 'portfolio_id',
    filter: 'portfolio_id'
  },
  {
    module_code_key: 'payment_batch',
    column_name: 'payment_processor_id',
    depend_column_name: 'portfolio_id',
    filter: 'portfolio_id'
  },
  {
    module_code_key: 'portfolio',
    column_name: 'zip_code_id',
    depend_column_name: 'state_dropdown_option_id',
    filter: 'state_dropdown_option_id'
  },
  {
    module_code_key: 'customer_note',
    column_name: 'result_code_tag_id',
    depend_column_name: 'activity_code_tag_id',
    filter: 'related_to_tag_id'
  },
  {
    module_code_key: 'campaign',
    column_name: 'template_id',
    depend_column_name: 'portfolio_id',
    filter: 'portfolio_id'
  }
]
